import { assign } from 'lodash';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-slide-wysiwyg-body',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.scss'],
    standalone: false
})
export class BodyComponent {
  #isSubmitted = signal(false);
  #page: FlatModels.PageEntityModels.BodyPageEntityType | null;
  bodyForm = new FormGroup(
    {
      body: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.PageEntityModels.SlideSchema.pick({
          body: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public nodeSharedFacade: FlatFacades.NodeSharedFacade) {
    // Update Page
    this.nodeSharedFacade.currentSelectedPage$.pipe(takeUntilDestroyed()).subscribe((page) => {
      // TODO use PageHasBody
      this.#page = structuredClone(page) as FlatModels.PageEntityModels.BodyPageEntityType;
      if (this.#page) {
        this.bodyForm.reset({body: this.#page.body || ''})
      }
      this.#isSubmitted.set(false);
    });
  }

  onSubmit() {
    if (this.#isSubmitted() || this.bodyForm.invalid || !this.#page) {
      return;
    }
    if (this.#page.body === this.bodyForm.value['body']) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Page
    const page = assign(this.#page, {
      body: this.bodyForm.value['body']
    });
    this.nodeSharedFacade.requestUpdatePage(page, 'history.page_update_body').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.bodyForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
